import { render, staticRenderFns } from "./BlockListTile.vue?vue&type=template&id=0284faa3&"
import script from "./BlockListTile.vue?vue&type=script&lang=ts&"
export * from "./BlockListTile.vue?vue&type=script&lang=ts&"
import style0 from "./BlockListTile.vue?vue&type=style&index=0&id=0284faa3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports